import {
  Icon,
  InViewContainer,
  MobileStickyCta,
} from "@trueskin-web/components"
import { formatCurrency, isFloat } from "@trueskin-web/functions"
import { arrowLongRightIcon } from "@trueskin-web/theme/icons/arrowLongRightIcon"

import SubmitButton from "../components/submit-button"
import withPresetsActions from "../components/with-presets-actions"
import { antiAgingPlanDetails } from "../resources"

import Plan from "./plan"
import Subscriptions from "./subscriptions"

const mapCurrentPresetsToPlans = (presets = []) => {
  if (!presets.length) {
    return []
  }

  return presets.map((currentPreset) => {
    const isSubscription = currentPreset.occurrence !== "occ_once"
    const instalments = currentPreset.summary.instalments.count
    const { total, totalWithoutDiscounts, currency } =
      currentPreset.summary.values.perInstalment

    const title = currentPreset.details.name

    const priceTitle = formatCurrency(
      total / 100,
      currency,
      isFloat(total / 100) ? 2 : 0
    )

    const priceWithoutDiscounts =
      total === totalWithoutDiscounts
        ? null
        : formatCurrency(totalWithoutDiscounts / 100, currency)

    const planKey = Object.keys(antiAgingPlanDetails).find((key) =>
      currentPreset.id.startsWith(key)
    )

    const details = planKey
      ? antiAgingPlanDetails[planKey].map((text) => ({
          content: text.replace("{{totalPrice}}", (total * instalments) / 100),
        }))
      : currentPreset.details.plan

    return {
      isSubscription,
      title,
      priceTitle,
      priceWithoutDiscounts,
      details,
      instalments,
      id: currentPreset.id,
      isSelected: currentPreset.isSelected,
      isRecommended: currentPreset.isRecommended,
      description: currentPreset.details.description,
      image: currentPreset.details.image,
    }
  })
}

const Plans = ({
  presetList,
  selectedPlanId,
  isSubmitting,
  onSelect,
  onSubmit,
}) => {
  const plans = mapCurrentPresetsToPlans(presetList)

  const [subscriptions, nonSubscriptions] = plans.reduce(
    (accum, curr) => {
      accum[curr.isSubscription ? 0 : 1].push(curr)
      return accum
    },
    [[], []]
  )

  const selectedPlan = plans.find((plan) => plan.id === selectedPlanId)

  const handleSubmit = (planId) => onSubmit(planId)

  return (
    <InViewContainer
      sx={{
        mb: 6,
        "& > h3": {
          fontFamily: "NeueHaasGroteskDisplay Pro",
          lineHeight: "smallerHeading",
        },
      }}
    >
      {({ isInView }) => (
        <>
          <div
            sx={{
              display: "grid",
              gridTemplateColumns: [null, "repeat(3, 1fr)"],
              gridTemplateRows: "auto",
              justifyContent: "center",
              gap: 4,
              pt: "40px",
              pb: 6,
              px: 4,
              background: ["lightBlue", "white"],
              marginLeft: ["-16px", "0px"],
              marginRight: ["-16px", "0px"],
            }}
            data-testid="web-portal-plan-selection-anti-aging-plans"
          >
            <Subscriptions
              plans={subscriptions}
              selectedPlan={selectedPlan}
              selectedPlanId={selectedPlanId}
              isSubmitting={isSubmitting}
              onSubmit={handleSubmit}
              onSelect={onSelect}
            />

            {nonSubscriptions.map((plan) => (
              <Plan
                key={plan.id}
                plan={plan}
                selectedPlanId={selectedPlanId}
                isSubmitting={isSubmitting}
                onSelect={onSelect}
                onSubmit={handleSubmit}
              />
            ))}
          </div>
          {!!selectedPlanId && (
            <SubmitButton
              as={MobileStickyCta}
              dataTestId="web-portal-plan-selection-mobile-cta"
              show={isInView}
              isLoading={isSubmitting}
              withArrow={false}
              title={
                <>
                  {selectedPlan.isSubscription
                    ? "Weiter mit Auto-Refill"
                    : `Weiter mit ${selectedPlan.title}`}
                  <Icon icon={arrowLongRightIcon} sx={{ mt: "2px", ml: 1 }} />
                </>
              }
              onClick={() => handleSubmit(selectedPlan.id)}
            />
          )}
        </>
      )}
    </InViewContainer>
  )
}

export default withPresetsActions(Plans)
